module.exports = __webpack_public_path__ + "img/key_active_night.a3a55420.svg";